import { v4 as uuid } from 'uuid';
import { eEstateType } from './eEstateType';
import { eDeedDocumentType } from './eDeedDocumentType';
import { DateTime } from 'luxon';

export interface IDeedResponse {
  id: string;
  created_at?: string;
  additional_information?: string | null;
  book?: string | null;
  consideration?: number | null;
  deed_date?: string | null;
  document_type?: eDeedDocumentType | null;
  estate_type?: eEstateType | null;
  grantee?: string | null;
  grantor?: string | null;
  instrument_number?: string | null;
  other_document_type?: string | null;
  other_estate_type?: string | null;
  recorded_date?: string | null;
}
export interface IDeedData {
  id: string;
  createdAt?: string;
  additionalInformation?: string | null;
  book?: string | null;
  consideration?: number | null;
  deedDate?: string | null;
  documentType?: eDeedDocumentType | null;
  estateType?: eEstateType | null;
  grantee?: string | null;
  grantor?: string | null;
  instrumentNumber?: string | null;
  otherDocumentType?: string | null;
  otherEstateType?: string | null;
  recordedDate?: string | null;
}

export const createDefaultDeedData = (): IDeedData => ({
  id: uuid(),
  createdAt: DateTime.local().toISO(),
});

export const convertDeedResponseToDeedData = (res: IDeedResponse): IDeedData => ({
  id: res.id,
  createdAt: res.created_at,
  additionalInformation: res.additional_information,
  book: res.book,
  consideration: res.consideration,
  deedDate: res.deed_date,
  documentType: res.document_type,
  estateType: res.estate_type,
  grantee: res.grantee,
  grantor: res.grantor,
  instrumentNumber: res.instrument_number,
  otherDocumentType: res.other_document_type,
  otherEstateType: res.other_estate_type,
  recordedDate: res.recorded_date,
});

export const convertDeedDataToDeedResponse = (data: IDeedData): IDeedResponse => ({
  id: data.id,
  created_at: data.createdAt,
  additional_information: data.additionalInformation,
  book: data.book,
  consideration: data.consideration,
  deed_date: data.deedDate,
  document_type: data.documentType,
  estate_type: data.estateType,
  grantee: data.grantee,
  grantor: data.grantor,
  instrument_number: data.instrumentNumber,
  other_document_type: data.otherDocumentType,
  other_estate_type: data.otherEstateType,
  recorded_date: data.recordedDate,
});
